import { Component, input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-sidebar-section',
  standalone: true,
  imports: [],
  template: `
    <section class="sidebar-section">
      <div class="section-header">
        @switch (headingLevel()) {
          @case (2) {
            <h2 [id]="headerId" class="mat-title-medium section-title">
              {{ title() }}
            </h2>
          }
          @default {
            <h3 [id]="headerId" class="mat-title-medium section-title">
              {{ title() }}
            </h3>
          }
        }
        @if (description()) {
          <p [id]="descriptionId" class="mat-body-small description">
            {{ description() }}
          </p>
        }
      </div>

      <div class="section-content">
        <ng-content />
      </div>
    </section>
  `,
  styles: [
    `
      .section-header {
        margin-bottom: var(--md-sys-spacing-medium);

        .section-title {
          color: var(--md-sys-color-on-surface-variant);
          margin: 0 0 var(--md-sys-spacing-extra-small) 0;
        }

        .description {
          color: var(--md-sys-color-on-surface-variant);
          margin: 0;
          opacity: 0.8;
        }
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidebarSectionComponent {
  title = input.required<string>();
  description = input<string>();
  headingLevel = input<2 | 3>(3);

  // Expose IDs for aria-labelledby/describedby usage by projected content
  headerId = `sidebar-section-${crypto.randomUUID().slice(0, 8)}`;
  descriptionId = `${this.headerId}-desc`;
}
